;(function () {
  "use strict";
  console.log('RELOADING JS');

  /* Globals */
  window.jQuery = window.$ = require('jquery');
  require('jquery.cookie');
  require('jquery-touch-events');

  window.Cookies = require('js-cookie');

  /* Bootstrap */
  window.Tether = require('tether');
  require('bootstrap');

  window._ = require('underscore');
  window.Backbone = require('backbone');
  window.imagesLoaded = require('imagesloaded');
  window.App = {};

  function noop() {}
  if ((window.location.href.indexOf('https://localhost:3000') === -1) && (window.location.href.indexOf('ngrok') === -1)){
    console.log = noop;
    console.warn = noop;
    console.error = noop;
  }

  App.guid = (function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
                 .toString(16)
                 .substring(1);
    }
    return function() {
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
             s4() + '-' + s4() + s4() + s4();
    };
  }());

  $.ajaxSetup({
      beforeSend: function(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken);
        console.log('beforesend');
        console.log(window.sessionToken);
      }
  });

  /* Global Events Delegator */
  window.App.Events = {};
  _.extend(window.App.Events, Backbone.Events);

  /* Switch this to bulkify or something */
  var Pages = {
    'index': require('./pages/index'),
    'config': require('./pages/config'),
    'configure-config': require('./pages/configure-config'),
    'upsert': require('./pages/upsert'),
    'list': require('./pages/list'),
    'import': require('./pages/import'),
    'export': require('./pages/export'),
    'import-csv': require('./pages/import-csv'),
    'upload-assets': require('./pages/upload-assets'),
    'export-csv': require('./pages/export-csv'),
    'object-config': require('./pages/object-config'),
    'configure-object-config': require('./pages/configure-object-config'),
    'object-list': require('./pages/object-list'),
    'object-upsert': require('./pages/object-upsert'),
    'settings': require('./pages/settings'),
    'permissions': require('./pages/permissions'),
    'install': require('./pages/install'),
    'charge': require('./pages/charge')
  };

  var AccordianView = Backbone.View.extend({
    initialize: function () {
      this.id = this.$el.data('id');

      this.visible = window.Cookies.get(this.id) === "false" ? false : true;
      this.update();
    },
    update: function () {
      if (this.visible) {
        $('#'+this.id).show();
        this.$el.addClass('visible');
      } else {
        $('#'+this.id).hide();
        this.$el.removeClass('visible');
      }

      window.Cookies.set(this.id, this.visible.toString(), { expires: 365, path: '', secure: true, sameSite: 'none' });
    },
    events: {
      'click span': function (e) {
        this.visible = !this.visible;
        this.update();
      }
    }
  })

  var globalSetup = require('./pages/global');

  $(document).on('ready turbolinks:render', function() {
    console.log('init page');
    window.Buttons = undefined;
    window.App.Events.off();

    var PageView = Pages[$('#page').attr('value')];
    /* Might want to wait until Shopify.ready to avoid edge cases when script take a long time to load... */
    if (PageView) {
      new PageView({ el: $('body') });
    }

    if (window.data.disableToggle) {
      $('.accordian-toggle').hide();
      $('.toggle-all').hide();      
    } else {
      if ($('.accordian-toggle').length < 150) {
        $('.accordian-toggle').each(function () {
          new AccordianView({el: this});
        });
      } else {
        $('.accordian-toggle').hide();
        $('.toggle-all').hide();
      }
    }

    $('a').each(function() {
      var href = $(this).attr('href');
      var shop = 'shop='+window.data.shop;

      if (href) {
        href += (href.match(/\?/) ? '&' : '?') + shop;
        $(this).attr('href', href);
      }

      $(this).attr('data-turbolinks-action', 'replace');
    });

    /* require global ShopifyAPI setup (header bar) */
    globalSetup();
  });

}());

